








































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { pageDataType } from "../types";
import { ADD_ANIMATION } from "../store/mutations.names";
import { HOST } from "../global";
import "swiper/dist/css/swiper.css";
import {
  TweenMax,
  Expo,
  Back,
  TimelineMax,
  Power1,
  Power2,
  Power4
} from "gsap";
import { swiper, swiperSlide } from "vue-awesome-swiper";

const interleaveOffset = 0.87;

@Component({
  name: "HeaderSlider",
  components: {
    swiper,
    swiperSlide
  }
})
export default class HeaderSlider extends Vue {
  @Prop() readonly slider!: any;
  @Getter("pageData") public pageData!: pageDataType;
  @Prop() public last!: boolean;
  @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
  @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
  @Mutation(ADD_ANIMATION) public [ADD_ANIMATION]: any;
  public addedAnimation: boolean = false;
  public HOST: string = HOST;
  swiper: any | null = null;

  public hdslideanim(): void {
   var hdslideanim = new TimelineMax({});
    hdslideanim
      .staggerFromTo(
        ".swiper-wrapper",
        0.6,
        {
          opacity: 0,
         
        },
        {
          opacity: 1,
          ease: Power1.easeOut,
          clearProps: "all"
        },.01,"-=5"
      )
      .staggerFrom(".title", 0.6, {
        y: "20%",
        autoAlpha: 0,
        opacity: 0,
        ease: Back.easeOut,
        clearProps: "all"
      },.01,"-=5");
    if (this.last) {
      this.$emit("loaded");
    }
  }



  swiperOption: any = {
    observer: true,
    loop: false,
    autoHeight: true,
    direction: "vertical",
    speed: 800,
    passiveListeners: true,
    touchReleaseOnEdges: true,
    simulateTouch: true,
    watchSlidesProgress: true,
    mousewheel: true,
    breakpoints: {  
   
      767: {       
        
          mousewheel: false,
          effect: 'fade',
          fadeEffect: {
          crossFade: true
          }
      },     
    },
    on: {
      progress: function() {
        let swiper = this as any;
        const breakpoint = window.matchMedia('(max-width: 767px)');
        for (let i = 0; i < swiper.slides.length; i++) {
          let slideProgress = swiper.slides[i].progress;
          let innerOffset = swiper.height * interleaveOffset;
          let innerTranslate = slideProgress * innerOffset;
         
          if ( breakpoint.matches === true ) {
            TweenMax.set(swiper.slides[i].querySelector(".slide-inner"), {
            opacity: 1,
            clearProps: "all",
            
          });
         }
         else {
            TweenMax.set(swiper.slides[i].querySelector(".slide-inner"), {
            y: innerTranslate,
            ease: Expo.easeInOut
          });
         }
        }
        
         if ( breakpoint.matches === true ) {
           swiper.autoplay.start();
         }
         else {
            swiper.autoplay.stop();	
         }
      },

      slideNextTransitionStart() {
       
        var classSelect = document.querySelectorAll(".transitioned");
        var numberclass = document.querySelectorAll(".transitioned").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.add("animate-up");
        }

        var classSelect = document.querySelectorAll(".swiper-slide");
        var numberclass = document.querySelectorAll(".swiper-slide").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.remove("transitioned");
        }
      },
      slidePrevTransitionStart() {
        var classSelect = document.querySelectorAll(".transitioned");
        var numberclass = document.querySelectorAll(".transitioned").length;
        // for (let i = 0; i < numberclass; i++) {
        //   classSelect[i].classList.add("animate-down");
        // }

        var classSelect = document.querySelectorAll(".swiper-slide");
        var numberclass = document.querySelectorAll(".swiper-slide").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.remove("transitioned");
        }
      },
      transitionEnd() {
        var classSelect = document.querySelectorAll(".swiper-slide");
        var numberclass = document.querySelectorAll(".swiper-slide").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.remove("animate-up", "animate-down");
        }

        var classSelect = document.querySelectorAll(".swiper-slide-active");
        var numberclass = document.querySelectorAll(".swiper-slide-active")
          .length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.add("transitioned");
        }
      },

      reachEnd: function() {
        let swiper = this as any;
        // if (swiper.slides.length - 1) {
        //   setTimeout(function() {
        //     swiper.mousewheel.disable();
        //   }, 550);
        // } else {
        //   swiper.mousewheel.enable();
        // }

        // if (swiper.isEnd == true) {
          // setTimeout(() => {
          //   swiper.mousewheel.disable();
          // }, 300);
         
          if (swiper.isEnd == true) {
            var scrollableElement = document.querySelector(".banner");
            (scrollableElement as any).addEventListener(
              "wheel",
              findScrollDirectionOtherBrowsers
            );

            function findScrollDirectionOtherBrowsers(event: any) {
              var delta;

              if (event.wheelDelta) {
                delta = event.wheelDelta;
              } else {
                delta = -1 * event.deltaY;
              }

              if (delta < 0) {
                 setTimeout(() => {
            swiper.mousewheel.disable();
          }, 550);
             //   console.log("DOWN");
              } else if (delta > 0) {
               swiper.mousewheel.enable();
               // console.log("UP");
              }
            }
          }
          // else{
          //    swiper.mousewheel.enable();
          // }
        
        // else {
        //   swiper.mousewheel.enable();
        // }
        //console.log("reachEND");
      },
      reachBeginning: function() {
        let swiper = this as any;
        //  swiper.mousewheel.enable();
        if (swiper.isBeginning == true) {
          swiper.mousewheel.enable();
        } else {
          swiper.mousewheel.enable();
        }

      //  console.log("rechbegining");
      },
      init: function() {
        let swiper = this as any;
        var classSelect = document.querySelectorAll(".swiper-slide-active");
        var numberclass = document.querySelectorAll(".swiper-slide-active")
          .length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.add("transitioned");
        }
      },
      touchEnd: function() {},
      touchStart: function() {
        let swiper = this as any;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = "";
        }
      },
      setTransition: function(speed: number) {
        let swiper = this as any;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = speed + "ms";
          swiper.slides[i].querySelector(".slide-inner").style.transition =
            speed + "ms";
        }
      }

    }
  };

  swiperScrollFunc() {
    let scrollpos = window.scrollY;
    let elm = this.$refs.slider as any;
    if (scrollpos > 10) {
      elm.swiper.mousewheel.disable();
    } else {
      elm.swiper.mousewheel.enable();
    }
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.swiperScrollFunc);
  }

/*
mainslider() {
     
        this.swiperOption = {
         observer: true,
    loop: true,
    autoHeight: true,
    direction: "horizontal",
    speed: 800,
    passiveListeners: true,
    touchReleaseOnEdges: true,
    simulateTouch: true,
    watchSlidesProgress: true,
    effect: 'fade',
    mousewheel: false,
        autoplay: {
        delay: 2500,
        disableOnInteraction: false,
         },
         on: {
      progress: function() {
        let swiper = this as any;
        for (let i = 0; i < swiper.slides.length; i++) {
          let slideProgress = swiper.slides[i].progress;
          let innerOffset = swiper.height * interleaveOffset;
          let innerTranslate = slideProgress * innerOffset;
          TweenMax.set(swiper.slides[i].querySelector(".slide-inner"), {
            y: innerTranslate,
            ease: Expo.easeInOut
          });
        }
      },

      slideNextTransitionStart() {
        var classSelect = document.querySelectorAll(".transitioned");
        var numberclass = document.querySelectorAll(".transitioned").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.add("animate-up");
        }

        var classSelect = document.querySelectorAll(".swiper-slide");
        var numberclass = document.querySelectorAll(".swiper-slide").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.remove("transitioned");
        }
      },
      slidePrevTransitionStart() {
        var classSelect = document.querySelectorAll(".transitioned");
        var numberclass = document.querySelectorAll(".transitioned").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.add("animate-down");
        }

        var classSelect = document.querySelectorAll(".swiper-slide");
        var numberclass = document.querySelectorAll(".swiper-slide").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.remove("transitioned");
        }
      },
      transitionEnd() {
        var classSelect = document.querySelectorAll(".swiper-slide");
        var numberclass = document.querySelectorAll(".swiper-slide").length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.remove("animate-up", "animate-down");
        }

        var classSelect = document.querySelectorAll(".swiper-slide-active");
        var numberclass = document.querySelectorAll(".swiper-slide-active")
          .length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.add("transitioned");
        }
      },

      reachEnd: function() {
        let swiper = this as any;
        // if (swiper.slides.length - 1) {
        //   setTimeout(function() {
        //     swiper.mousewheel.disable();
        //   }, 550);
        // } else {
        //   swiper.mousewheel.enable();
        // }

        // if (swiper.isEnd == true) {
          // setTimeout(() => {
          //   swiper.mousewheel.disable();
          // }, 300);
         
          if (swiper.isEnd == true) {
            var scrollableElement = document.querySelector(".banner");
            (scrollableElement as any).addEventListener(
              "wheel",
              findScrollDirectionOtherBrowsers
            );

            function findScrollDirectionOtherBrowsers(event: any) {
              var delta;

              if (event.wheelDelta) {
                delta = event.wheelDelta;
              } else {
                delta = -1 * event.deltaY;
              }

              if (delta < 0) {
                 setTimeout(() => {
            swiper.mousewheel.disable();
          }, 550);
                console.log("DOWN");
              } else if (delta > 0) {
               swiper.mousewheel.enable();
                console.log("UP");
              }
            }
          }
          // else{
          //    swiper.mousewheel.enable();
          // }
        
        // else {
        //   swiper.mousewheel.enable();
        // }
        console.log("reachEND");
      },
      reachBeginning: function() {
        let swiper = this as any;
        //  swiper.mousewheel.enable();
        if (swiper.isBeginning == true) {
          swiper.mousewheel.enable();
        } else {
          swiper.mousewheel.enable();
        }

        console.log("rechbegining");
      },
      init: function() {
        let swiper = this as any;
        var classSelect = document.querySelectorAll(".swiper-slide-active");
        var numberclass = document.querySelectorAll(".swiper-slide-active")
          .length;
        for (let i = 0; i < numberclass; i++) {
          classSelect[i].classList.add("transitioned");
        }
      },
      touchEnd: function() {},
      touchStart: function() {
        let swiper = this as any;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = "";
        }
      },
      setTransition: function(speed: number) {
        let swiper = this as any;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = speed + "ms";
          swiper.slides[i].querySelector(".slide-inner").style.transition =
            speed + "ms";
        }
      }
      
    }






        }
        
       
}
*/


  public mounted() {
//   let mbdisplay = window.matchMedia("screen and (max-width: 991px)")
// if (mbdisplay.matches){ 
//  this.mainslider();
// }
// else{
  
// }
    // document.addEventListener("DOMContentLoaded", function(event) {
    //   let d: any = document;
    //   var mainbody = d.querySelector("body");
    //   var mnNav = d.querySelector(".main-navigation");
    //   mainbody.onwheel = function() {
    //     return false;
    //   };
    //   mnNav.onwheel = function() {
    //     return false;
    //   };
    //   setTimeout(function() {
    //     mainbody.onwheel = function() {
    //       return true;
    //     };
    //   }, 5000);
    // });
    window.addEventListener("scroll", this.swiperScrollFunc);
  }
  
}


